import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-font-awesome-layers',
	templateUrl:'./FontAwesomeLayersPluginCompPage.html',
	styles: [],
	styleUrls:['./FontAwesomeLayersPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class FontAwesomeLayersPluginCompPage
{
	mdContent_938 = `\`\`\`java
import com.jwebmp.plugins.fontawesome5.FontAwesomeLayers;
\`\`\``;
	mdContent_939 = `\`\`\`java
FontAwesomeLayers()
\`\`\``;
	mdContent_940 = `\`\`\`java
var layers = new FontAwesomeLayers<>()
    .addIcon(new FontAwesome<>(FontAwesomeStyles.Classic, FontAwesomeIcons.envelope))
    .addCounter(new FontAwesomeLayerCounter<>().setText("99+"));
\`\`\``;
	mdContent_941 = `\`\`\`java
var layers = new FontAwesomeLayers<>()
    .setSize(FontAwesomeSizes.$3x)
    .addIcon(new FontAwesome<>(FontAwesomeStyles.Classic, FontAwesomeIcons.circle))
    .addIcon(new FontAwesome<>(FontAwesomeStyles.Classic, FontAwesomeIcons.check)
        .inverse()
        .transform(FontAwesomeTransforms.Shrink_6));
\`\`\``;
	mdContent_942 = `\`\`\`java
var layers = new FontAwesomeLayers<>()
    .addIcon(new FontAwesome<>(FontAwesomeStyles.Classic, FontAwesomeIcons.certificate))
    .addText(new FontAwesomeLayerText<>().setText("NEW")
        .transform(FontAwesomeTransforms.Shrink_4));
\`\`\``;
}
